<template>
  <div class="list-main">
    <div class="tab-container">
      <table class="nav-table" border="0" cellspacing="0" cellpadding="0">
        <tbody>
          <tr align="center">
            <td
              :class="status == 1 ? 'activation' : ''"
              @click="handleStatus(1)"
            >
              可用
            </td>
            <td
              :class="status == 0 ? 'activation' : ''"
              @click="handleStatus(0)"
            >
              全部
            </td>
            <td
              :class="status == 2 ? 'activation' : ''"
              @click="handleStatus(2)"
            >
              失效
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ul class="all list-ul">
      <li
        v-for="(item, index) in ListCoupon"
        :key="(item, index)"
        :class="item.IsExpired ? 'card_invalid' : ''"
        @click="handleCardClick(index)"
      >
        <div class="card-logo-group">
          <div class="logo"><img src="../../public/img/xz-logo.png" /></div>
          <div class="card-title">{{ item.ProductName }}</div>
        </div>
        <img :src="item.CoverPictureUri" />
        <div class="card-foot">
          <div class="card-time">
            <span class="time-field">有效期</span>
            <template v-if="item.timeStatus == '未生效'">
              <span class="time">未生效</span>
            </template>
            <template v-if="item.timeStatus == ''">
              <span
                class="time"
                v-if="
                  (item.TicketType === 4 && !item.IsExpired) ||
                  item.Status === 30
                "
                >{{ item.ExpirationTime.replace("T", " ") }}</span
              >
              <span
                class="time"
                v-if="
                  (item.TicketType === 1 ||
                    item.TicketType === 2 ||
                    item.TicketType === 3 ||
                  item.TicketType === 5) &&
                  item.Status === 20
                "
                >未激活</span
              >
              <span class="time" v-if="item.IsExpired">已失效</span>
            </template>
          </div>
          <div class="card-number">
            <span class="number-field">剩余可乘车</span>
            <span class="number">{{ item.RemainingCount }}</span>
            <span class="number-field">次</span>
          </div>
        </div>
      </li>
      <div
        class="mdui-spinner mdui-spinner-colorful loading"
        v-show="isLoading"
      ></div>
      <div class="label_nomore" v-show="!isHasElse">
        <i></i>
        <span>已加载所有内容</span>
      </div>
    </ul>
    <div class="convert-btn" @click="rewardTicket()">
      <div class="convert-group">
        <div class="convert-btn-img"></div>
        <div class="btn-text">使用兑换码兑换</div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../utils/util'

export default {
  name: 'List',
  data () {
    return {
      status: 1,
      ListCoupon: [],
      ListUsedCoupon: [],
      isHasElse: false,
      isLoading: false,
      pageIndex: 1
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.mdui.mutation()
    if (this.$store.state.Token) {
      this.autoSyncTicket(this.getList)
    } else {
      this.mdui.dialog({
        title: '提示',
        content: '请登录查看相关信息',
        history: false,
        buttons: [
          {
            text: '确认',
            onClick: (inst) => {
              this.$router.push({
                path: '/exchange',
                query: this.$route.query
              })
            }
          }
        ]
      })
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      if (
        getScrollHeight() - getScrollTop() - getClientHeight() < 1 &&
        !this.isLoading &&
        this.isHasElse
      ) {
        console.log(getScrollHeight())
        console.log(getScrollTop())
        console.log(getClientHeight())
        console.log(getScrollHeight() - getScrollTop() - getClientHeight())
        this.pageIndex++
        this.getList(true)
      }
    },
    handleStatus (i) {
      if (this.isLoading) return
      util.addmatomo(
        'qrcode_myticket_type_tab_click_event',
        'qrcode_myticket_type_tab_click_event',
        i
      )
      this.status = i
      this.pageIndex = 1
      this.isHasElse = true
      this.getList()
    },
    handleCardClick (index) {
      let clickGuidCoupon = this.ListCoupon[index].GuidCoupon
      let q = {
        ...this.$route.query,
        guid: clickGuidCoupon,
        refreshguid: Math.random()
      }
      if (
        this.ListCoupon[index].Status === 20 ||
        this.ListCoupon[index].Status === 30
      ) {
        util.addmatomo(
          'qrcode_myticket_detail_click_event',
          'qrcode_myticket_detail_click_event',
          clickGuidCoupon
        )
        this.$router.push({ path: '/preview', query: q })
        window.sessionStorage.setItem('GuidCoupon', clickGuidCoupon)
      }
    },
    getList (isMore) {
      if (!isMore) {
        this.ListCoupon = []
      }
      this.isLoading = true
      this.$axios
        .post(
          '/qca/ticket/list',
          { Index: this.pageIndex, Size: 20, Status: this.status },
          'ticket'
        )
        .then((data) => {
          this.isLoading = false
          if (data) {
            if (data.Code === 200) {
              this.ListCoupon = this.ListCoupon.concat(data.Data.Items)
              this.isHasElse = data.Data.HasElse
              this.handleListCoupon()
              this.handleListtime()
            } else if (data.Code === -404) {
            } else {
              if (data.Message) {
                this.mdui.alert(data.Message, '提示', data.Message, {
                  history: false
                })
              }
            }
          }
        })
        .catch((e) => console.log(e))
    },
    handleListCoupon () {
      this.ListCoupon.forEach(function (item) {
        item.IsExpired = !(item.Status === 20 || item.Status === 30)
      })
    },
    handleListtime () {
      this.ListCoupon.forEach(function (item) {
        // 判断当前时间是否小于开始时间
        if (item.EffectiveTime) {
          let startTime = new Date(item.EffectiveTime.replace(/-/g, '/'))
          let nowTime = new Date()
          if (nowTime.getTime() < startTime.getTime()) {
            item.timeStatus = '未生效'
          } else {
            item.timeStatus = ''
          }
        }
      })
    },
    rewardTicket () {
      util.addmatomo(
        'qrcode_myticket_exchange_click_event',
        'qrcode_myticket_exchange_click_event',
        1
      )
      this.$router.push({ path: '/exchange', query: this.$route.query })
    },
    autoSyncTicket (callback) {
      this.$axios
        .post('/tp/api/activity/coupon/all/activityrewardbyautosync', null)
        .then((data) => {
          if (data) {
            if (data.Code !== 200) {
              console.log(data.Message)
            }
          }
          callback()
        })
        .catch((e) => console.log(e))
    }
  }
}

function getClientHeight () {
  var clientHeight = 0
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight =
      document.body.clientHeight < document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight
  } else {
    clientHeight =
      document.body.clientHeight > document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight
  }
  return clientHeight
}

// 取窗口滚动条高度
function getScrollTop () {
  var scrollTop = 0
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop
  } else if (document.body) {
    scrollTop = document.body.scrollTop
  }
  return scrollTop
}

// 取文档内容实际高度
function getScrollHeight () {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight
  )
}
</script>

<style scoped>
.list-main {
  background-color: #f5f5f5;
  height: 100%;
}

.list-ul {
  margin: 0 auto;
  padding: 0;
  list-style: none;
  margin-top: 55px;
  width: 94%;
}

.list-ul li {
  position: relative;
  width: 100%;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 15px;
  border-radius: 4px;
  overflow: hidden;
}

.list-ul li img {
  width: 100%;
}

.tab-container {
  position: fixed;
  width: 100%;
  top: 0;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.03);
  z-index: 1;
}

.nav-table {
  width: 100%;
  height: 44px;
  background-color: #ffffff;
  top: 0;
}

.nav-table tr td {
  font-size: 1.7rem;
  color: #999999;
  position: relative;
}

.nav-table tr .activation {
  color: #b93741;
}

.nav-table tr .activation:after {
  content: "";
  height: 3px;
  width: 26px;
  background-color: #b93741;
  display: inline-block;
  border-radius: 6px;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -13px;
}

.line-box {
  display: block;
  text-align: center;
  width: 33.33%;
  left: 0;
}

.card-foot {
  position: absolute;
  bottom: 0;
  height: 21.25%;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  border-radius: 0 0 4px 4px;
}

.card-foot .card-time,
.card-foot .card-number {
  display: block;
  height: 20px;
  line-height: 20px;
  position: absolute;
  top: 50%;
  margin-top: -10px;
  font-size: 1.2rem;
}

.card-foot .card-time {
  left: 10px;
}

.time-field,
.number-field {
  color: #ffffff;
  opacity: 0.5;
}

.card-time .time {
  color: #ffffff;
  margin-left: 5px;
}

.card-foot .card-number {
  right: 10px;
}

.number {
  color: #ffffff;
  font-weight: bold;
  font-size: 1.7rem;
  margin: 0 5px;
}

.card-logo-group {
  overflow: hidden;
  height: 24px;
  position: absolute;
  left: 15px;
  top: 15px;
}

.card-logo-group .logo {
  width: 24px;
  height: 24px;
  float: left;
}

.card-logo-group .card-title {
  height: 24px;
  line-height: 24px;
  font-size: 1.7rem;
  font-weight: bold;
  float: left;
  color: #ffffff;
  margin-left: 5px;
}

.label_nomore {
  width: 100%;
  overflow: hidden;
  float: left;
  position: relative;
  height: 20px;
  margin-top: 10px;
  margin-bottom: 40px;
}

.label_nomore i {
  display: block;
  width: 60%;
  height: 1px;
  background-color: #dddddd;
  position: absolute;
  left: 20%;
  top: 9px;
}

.label_nomore span {
  display: block;
  width: 100px;
  height: 20px;
  line-height: 20px;
  background-color: #f5f5f5;
  font-size: 12px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  text-align: center;
  color: #999999;
}

.card_invalid {
  filter: grayscale(100%);
}

.convert-btn {
  position: fixed;
  background-color: #ba3541;
  color: #ffffff;
  font-size: 17px;
  bottom: 20px;
  width: 94%;
  text-align: center;
  left: 50%;
  margin-left: -47%;
  padding: 13px 0;
  border-radius: 4px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
}

.convert-group {
  overflow: hidden;
  text-align: center;
  display: inline-block;
}

.convert-btn-img {
  width: 20px;
  height: 20px;
  background-image: url(../../public/img/convert-btn-img.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  float: left;
  margin-right: 10px;
}

.btn-text {
  float: left;
}
</style>
